<template>
  <div class="pay-delivery-info">
    <span v-for="item in config" class="pay-delivery-info-item" :key="item.key">
      <span class="pay-delivery-check" aria-hidden="true"></span>
      {{ item.name }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'device-pay-delivery-info',
  data () {
    return {
      config: Object.freeze([
        {
          name: this.$t('pdp.payAndDelivery.deliveryToAddress'),
          key: 'to-address'
        },
        {
          name: this.$t('pdp.payAndDelivery.posCollection'),
          key: 'pos-collection'
        },
        {
          name: this.$t('pdp.payAndDelivery.payOnCollection'),
          key: 'pay-on-collection'
        },
        {
          name: this.$t('pdp.payAndDelivery.payWithCard'),
          key: 'pay-with-card'
        }
      ])
    }
  }
}
</script>

<style lang="scss" scoped>
.pay-delivery-info {
  display: flex;
  flex-wrap: wrap;
  border: .1rem solid $price-separator;
  border-radius: .5rem;
  margin-bottom: 2.4rem;
  padding: 1rem;

  @media (map_get($breakpoints, sm)) {
    position: absolute;
    right: 0;
    bottom: 100%;
    max-width: 33.5rem;
  }

  @media (map_get($breakpoints, md)) {
    bottom: 0;
    margin-bottom: -5px;
    padding-bottom: 0;
    flex-wrap: nowrap;
    flex-direction: column;
  }
}

.pay-delivery-info-item {
  display: flex;
  flex: 0 0 50%;
  font-size: 1.2rem;

  &:first-child {
    margin-bottom: 1.6rem;
  }

  @media (map_get($breakpoints, md)) {
    margin-bottom: 1.3rem;
  }
}

.pay-delivery-check {
  position: relative;
  display: inline-block;
  border-radius: .5rem;
  margin-right: .8rem;
  width: 2rem;
  height: 2rem;
  background: $white;

  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    content: url('/assets/images/checkmark-black.svg');
  }
}
</style>
